/**
 * @generated SignedSource<<bb9649ccbb1bea617a8d7ed7c7db9760>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "Pooltick",
    "kind": "LinkedField",
    "name": "createPooltick",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "claim",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PooltickService",
        "kind": "LinkedField",
        "name": "pooltickService",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mrchntd",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Service",
            "kind": "LinkedField",
            "name": "service",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "paymentMethodCreatePooltickMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "paymentMethodCreatePooltickMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e02112b7b61a92f58730fb0ba51a9bf7",
    "id": null,
    "metadata": {},
    "name": "paymentMethodCreatePooltickMutation",
    "operationKind": "mutation",
    "text": "mutation paymentMethodCreatePooltickMutation(\n  $request: PooltickRequestInput!\n) {\n  createPooltick(request: $request) {\n    id\n    claim\n    pooltickService {\n      mrchntd\n      service {\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "5d7909fa75635d63a87d25b6c7b881dd";

module.exports = node;
